module.exports = __webpack_public_path__ + "static/media/profesoraResumen.e3d3a37a.svg";